export default [
    {
        path: 'relatorio-coleta-realizada',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-coleta-realizada' */
            '@/views/exame-laboratorial/relatorio-coleta-realizada/Index'),
        redirect: 'relatorio-coleta-realizada/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-coleta-realizada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-coleta-realizada' */
                    '@/views/exame-laboratorial/relatorio-coleta-realizada/List.vue'),
            },
        ],
    },
]